import { useNavigate } from 'react-router-dom'
import { ChevronLeftIcon } from '@/shared/ui/icons'
import { focusRingClasses } from '@/shared/lib/focusRing'

interface BackButtonProps {
  /** Rota de fallback quando não há histórico (ex.: abriu em nova aba). */
  fallbackTo?: string
  /** Quando true, sempre navega para fallbackTo em vez do histórico. Útil para seções principais (Documentos, Pacientes) onde "Voltar ao início" deve ir ao dashboard. */
  alwaysGoToFallback?: boolean
  /** Label de acessibilidade. */
  'aria-label'?: string
  /** Texto exibido (padrão: "Voltar"). */
  label?: string
  className?: string
}

const STYLE_MINT =
  'mb-2 inline-flex min-h-11 items-center gap-1.5 rounded-lg px-1 text-sm font-semibold text-[var(--color-link)] transition-colors hover:text-[var(--color-link)]/80'

export const BackButton = ({
  fallbackTo = '/settings',
  alwaysGoToFallback = false,
  'aria-label': ariaLabel = 'Voltar',
  label = 'Voltar',
  className,
}: BackButtonProps) => {
  const navigate = useNavigate()

  const handleClick = () => {
    if (alwaysGoToFallback && fallbackTo) {
      navigate(fallbackTo)
    } else if (window.history.length > 1) {
      navigate(-1)
    } else {
      navigate(fallbackTo)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={className ? `${STYLE_MINT} ${focusRingClasses} ${className}` : `${STYLE_MINT} ${focusRingClasses}`}
      aria-label={ariaLabel}
    >
      <ChevronLeftIcon size={18} aria-hidden />
      {label}
    </button>
  )
}
